import { render } from "./LightingProduct.vue?vue&type=template&id=349c9ba3&scoped=true"
const script = {}

import "./LightingProduct.vue?vue&type=style&index=0&id=349c9ba3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349c9ba3"]])

export default __exports__